<template lang="html">
  <div class="container-fluid">
    <div>
      <chart :chart-data="datacollection"></chart>
    </div>
    <form v-on:submit.prevent="runprojection" class="form-inline">
     <div class="form-group">
       <div class="input-group">
          <input type="number" min="0" max="10" step="1" v-model="returnpct" class="form-control" id="validationTooltipUsername" placeholder="Return" aria-describedby="validationTooltipUsernamePrepend" required>
          <div class="input-group-append">
           <span class="input-group-text" id="validationTooltipUsernamePrepend">%</span>
          </div>
          <div class="input-group-append">
            <button class="btn btn-primary">Run Projection</button>
          </div>
        </div>
      </div>
     <div class="form-group mx-sm-3 mb-2">
         <div v-if="progress">
         <div class="spinner-border" role="status">
          </div>
            <span>{{progress}}</span>
        </div>
      </div>
    </form>
    <div>
      <span>{{successpct}}% chance of success</span>
      </div>
  </div>

</template>

<script>
import db from './firebaseInit'
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/performance');
require('@firebase/functions');
import Chart  from '@/components/LineChart.js'
import { Line } from 'vue-chartjs'


export default {
  name: 'linechart',
  components: {
      Chart
    },
  extends: Line,
  data () {
    return {
      datacollection: null,
      datayear: [],
      dataaum: [],
      datamin: [],
      datamax: [],
      successpct: 0,
      returnpct: null,
      progress: null
    }
    
  },
  mounted: function(){
   this.fillData()
  },
  methods: {
  fillData () {
        var userId
        this.datayear = []
        this.dataaum = []
        this.datamin = []
        this.datamax = []
        var user = firebase.auth().currentUser;
        if (user != null) {
          userId = user.uid;
        } 

          db.collection('users').doc(userId).collection('projections').doc('proj').get().then
          (doc => { 
              var i;
              this.successpct = doc.data().success
              for (i = 0; i < doc.data().projection.length; i++) { 
               //console.log(doc.data().projection[i].Year);
               const yrdata = doc.data().projection[i].Year
               const aumdata = doc.data().projection[i].AUM
               const mindata = doc.data().projection[i].MIN
               const maxdata = doc.data().projection[i].MAX
               this.datayear.push(yrdata)
               this.dataaum.push(aumdata)
               this.datamin.push(mindata)
               this.datamax.push(maxdata)
            }
            
            //console.log(this.dataaum)

            //const distinctyears = [...new Set(this.datayear)]
           // console.log(distinctyears)
          this.datacollection = {
          labels: this.datayear,
          datasets: [
            {
              label: 'Projection',
              borderColor: '#25455b',
              data: this.dataaum
            },
            {
              label: 'Max',
              borderColor: '#508a51',
              data: this.datamax
            },            {
              label: 'Min',
              borderColor: '#c5203a',
              data: this.datamin
            }
          ]
        }
          })


      },
  runprojection: function(){

var proj = firebase.functions().httpsCallable('projection');
this.progress = "Calculating"
proj({retpct: this.returnpct}).then(result => {
  console.log(result.data.text)
  this.returnpct = null
  this.progress = null
  this.fillData()

}).catch(error => {
  // Getting the Error details.
  var code = error.code;
  var message = error.message;
  var details = error.details;
  // ...
});
//this.returnpct = null
  }
  },
  computed: {
  }

}
</script>